import type { SpacesConfig, SpaceTemplate } from 'feature/editorial-dash/spaces';
import type { Feature } from 'util/stdtypes';
import { t } from 'util/stdtypes';

export const ConversationHelperTemplate: SpaceTemplate = {
    key: 'conversation-helper',
    label: t('Conversation Helper'),
    description: t('Give public guidance and feedback on conversations with the help of an AI chatbot.'),
    imageUrl: 'images/conversation-helper.svg',
    structureKey: 'question',
    featuresEnabled: ['conversationhelper'],
};

export const ConversationHelperTemplateFeature: Feature<SpacesConfig, {}> = {
    key: 'conversation-helper-template',
    name: 'Conversation Helper Template',
    dev: true,
    providesConfig: {
        templates: [ConversationHelperTemplate],
    },
};
